import { useMutation } from "@apollo/client";
import { useQueryClient } from "@tanstack/react-query";
import { graphql } from "gql/apollo";
import { useCallback } from "react";
import { useActiveAccount } from "utils/useActiveAccount";

export const EnableOutgoingWebhook = graphql(/* GraphQL */ `
	mutation EnableOutgoingWebhook($params: EnableOutgoingWebhookParams!) {
		enableOutgoingWebhook(params: $params) {
			error {
				code
				message
			}
			success
		}
	}
`);

export function useEnableOutgoingWebhook() {
	const [enableOutgoingWebhook] = useMutation(EnableOutgoingWebhook);
	const { userId, _id: accountId } = useActiveAccount();
	const queryClient = useQueryClient();

	const handleEnableOutgoingWebhook = useCallback(
		async (webhookId: string) => {
			const result = await enableOutgoingWebhook({
				variables: {
					params: {
						_id: webhookId,
					},
				},
			});

			await queryClient.invalidateQueries([
				"user",
				userId,
				"account",
				accountId,
				"outgoingWebhooks",
			]);

			return {
				success: result.data?.enableOutgoingWebhook.success,
				error: result.data?.enableOutgoingWebhook.error,
			};
		},
		[accountId, enableOutgoingWebhook, queryClient, userId]
	);

	return { handleEnableOutgoingWebhook };
}
